import { useTranslation } from "react-i18next";

const TableDataText = ({ data }) => {
  const { t } = useTranslation();
  if (data) return <th>{t(data.toUpperCase())}</th>;
  else return <th></th>;
};

export default TableDataText;
